import React from 'react';
import Footer from '../components/Footer';
import GamePage from '../components/GamePage';

import BalloonsOdyssey_Settings_Img1 from '../images/balloonsodyssey/images-15.png';


export default function BalloonsOdyssey_Settings() {
  return (
    <>
      <GamePage
        name="Balloons Odyssey: settings panel"
        description="Panel fully designed in Adobe Illustrator."
        images={[BalloonsOdyssey_Settings_Img1]}
        conclusion="Already implemented in the game Balloons Odyssey."
      />
      <Footer />
    </>
  );
}